interface StoreListType {
  id: string | number
  name: string
  isuse: number
  desc: string
}

export function isIphone() {
  return /iphone/.test(navigator.userAgent.toLowerCase())
}

export function isAphone() {
  return /android/.test(navigator.userAgent.toLowerCase())
}

export function isIpad() {
  return /ipad/.test(navigator.userAgent.toLowerCase())
}

/**
 * 是否在APP内
 */
export function isInApp() {
  return /imgo/.test(navigator.userAgent.toLowerCase())
}

export function stringifyParam(params: any) {
  const keys = Object.keys(params)
  if (!keys.length) return ''
  if (keys.length == 1) return `${keys[0]}=${params[keys[0]]}`
  return keys.reduce((before, after) => {
    return `${before}=${params[before]}&${after}=${params[after]}`
  })
}

/**
 *
 * @param url
 * @param params 需要的额外参数对象
 */
export function jumpPage(url: string, params = {}) {
  const strParam = stringifyParam(params)
  if (strParam) {
    url += url.indexOf('?') > -1 ? `&${strParam}` : `?${strParam}`
  }

  if (url.indexOf('imgotv://') > -1 || !isInApp()) {
    window.location.href = url
  } else {
    MgtvApi.jumpPage({ url })
  }
}

/**
 * @name: setStoreFormat stroe 格式转换
 * @param {type}
 * @return: Array list
 */
export function setStoreFormat(data: Array<object>): Array<object> {
  let list: Array<object> = []
  if (data) {
    list = data.map(item => {
      const { id, name } = item as StoreListType
      return Object.assign({}, { id, text: name, disable: false }, item)
    })
  }
  list.push({
    disable: false,
    id: '',
    text: '不参与',
  })
  return list
}

/**
 * @name: 本地随机验证码
 * @param {type}
 * @return: string
 */
export function uuid4() {
  const r = Math.random,
    p = '0000000',
    n = 0x100000000
  let a = ((r() * n) >>> 0).toString(16),
    b = ((((r() * n) & 0xffff4fff) | 0x4000) >>> 0).toString(16),
    c = ((((r() * n) & 0xbfffffff) | 0x80000000) >>> 0).toString(16),
    d = ((r() * n) >>> 0).toString(16)
  if (a.length < 8) {
    a = (p + a).slice(-8)
  }
  if (b.length < 8) {
    b = (p + b).slice(-8)
  }
  if (c.length < 8) {
    c = (p + c).slice(-8)
  }
  if (d.length < 8) {
    d = (p + d).slice(-8)
  }
  return [a, b.slice(0, 4), b.slice(4), c.slice(0, 4), c.slice(4) + d].join('-')
}

export function parseQuery(link: any) {
  const url = link ? link : location.href
  const theRequest: any = {}

  if (url.indexOf('?') != -1) {
    const str = url.substr(url.indexOf('?') + 1)
    const strs = str.split('&')

    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }

  return theRequest
}
